import { render, staticRenderFns } from "./mediaPhoneExamine.vue?vue&type=template&id=60e491da&scoped=true"
import script from "./mediaPhoneExamine.vue?vue&type=script&lang=ts"
export * from "./mediaPhoneExamine.vue?vue&type=script&lang=ts"
import style0 from "./mediaPhoneExamine.vue?vue&type=style&index=0&id=60e491da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e491da",
  null
  
)

export default component.exports